class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.overlay = document.querySelector('[data-cart-notif-overlay]');
    this.addonSize = document.querySelector('[data-addons-size]');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);

    this.overlay.classList.add('c-navOverlay--visible');
    document.body.classList.add('u-noScroll');

    const $sizeEl = document.querySelector('[data-notif-size]');
    const size = $sizeEl.dataset.notifSize;
    if(size && this.addonSize) {
      this.addonSize.textContent = size;
    }
    const $header = document.querySelector('.scrolled-past-header');
    if ($header) $header.classList.remove('scrolled-past-header');
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
    if (this.activeElement) {
      this.activeElement.focus();
    }

    this.header.querySelector('.header')?.classList.remove('behind-cart');
    this.overlay.classList.remove('c-navOverlay--visible');
    document.body.classList.remove('u-noScroll');
  }

  updateTotal() {
    fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: data.currency,      
      });
      const $cartTotal = document.querySelector('[data-cart-total]');
      const $progress = document.querySelector('[data-cart-notification-progress]');
      const rawValue = data.total_price.toString();
      const rawvalue2 = rawValue.slice(0,-2) + "." + rawValue.slice(-2);
      const totalFormatted = formatter.format(rawvalue2);
      const rawTotal = Number(rawValue);

      $cartTotal.textContent = totalFormatted;
      $cartTotal.dataset.cartTotal = rawValue;

      if ($progress) {
        const threshold = Number($progress.dataset.cartNotificationProgress);
        if(rawTotal >= threshold) {
          $progress.style.width = '100%';
        } else {
          var progress = (rawTotal / threshold) * 100;
          $progress.style.width = `${progress}%`;
        }
      }
    });
  }

  renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      this.updateTotal();

      if (this.header) {
        this.header.querySelector('.c-header')?.classList.add('behind-cart');
        this.header.reveal()
      };
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : this.activeElement;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
